import { IGetObraChecklistServicoCamposUseCase } from "../../../presentation/useCases/read/get_obra_checklist_servico_campos_use_case";
import { ObraChecklistServicoCampos } from "../../models/obra_checklist_servico_campos";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetObraChecklistServicoCamposUseCase
 */

export class GetObraChecklistServicoCamposUseCase implements IGetObraChecklistServicoCamposUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getObraChecklistServicoCampos(
    idObraChecklistServico: number | undefined,
  ): Promise<ObraChecklistServicoCampos> {
    if (idObraChecklistServico === undefined) throw new Error('Falha ao obter id de checklist de serviço!');
    const response = await this.repository.getObraChecklistServicoCampos(idObraChecklistServico);
    if (response === null) throw new Error('Falha ao obter campos do checklist de serviço!');
    return response;
  }
}
